export const common = {
    // Navigation
    nav: {
        home: 'Início',
        products: 'Produtos',
        about: 'Sobre',
        contact: 'Contato',
        cart: 'Carrinho',
        account: 'Conta',
    },
    // Actions
    actions: {
        add: 'Adicionar',
        remove: 'Remover',
        edit: 'Editar',
        delete: 'Excluir',
        create: 'Criar',
        save: 'Salvar',
        cancel: 'Cancelar',
        confirm: 'Confirmar',
        search: 'Buscar',
        filter: 'Filtrar',
        sort: 'Ordenar',
        apply: 'Aplicar',
        clear: 'Limpar',
        back: 'Voltar',
        next: 'Próximo',
        previous: 'Anterior',
        submit: 'Enviar',
        loading: 'Carregando...',
        close: 'Fechar',
    },
    // Messages
    messages: {
        success: 'Operação realizada com sucesso',
        error: 'Ocorreu um erro',
        notFound: 'Não encontrado',
        unauthorized: 'Não autorizado',
        forbidden: 'Acesso negado',
        validationError: 'Erro de validação',
        networkError: 'Erro de conexão',
        tryAgain: 'Tente novamente',
    },
    // Form labels
    form: {
        email: 'E-mail',
        password: 'Senha',
        name: 'Nome',
        phone: 'Telefone',
        address: 'Endereço',
        city: 'Cidade',
        state: 'Estado',
        zip: 'CEP',
        country: 'País',
        required: 'Obrigatório',
        optional: 'Opcional',
    },
    // Common terms
    common: {
        price: 'Preço',
        quantity: 'Quantidade',
        total: 'Total',
        subtotal: 'Subtotal',
        shipping: 'Frete',
        discount: 'Desconto',
        free: 'Grátis',
        outOfStock: 'Fora de estoque',
        inStock: 'Em estoque',
        available: 'Disponível',
        unavailable: 'Indisponível',
        allRightsReserved: 'Todos os direitos reservados',
        yes: 'Sim',
        no: 'Não',
    },
};
//# sourceMappingURL=common.js.map